import React from "react"

import Layout from "../components/top/Layout"
import SEO from "../components/Seo"
import Concept from "../components/top/Concept"
import Projects from "../components/top/Projects"
import Contact from "../components/top/Contact"
import GattoboInfo from "../components/top/GattoboInfo"
import Particles from "../components/shared/Particles"

const IndexPage = () => (
  <>
    <Particles />
    <div className="relative">
      <Layout>
        <SEO />
        <GattoboInfo />
        <Concept />
        <Projects />
        <Contact />
      </Layout>
      {/* tsparticleの動作の為にCDNを読み込む */}
      <script src="https://cdn.jsdelivr.net/npm/@tsparticles/preset-bubbles@3/tsparticles.preset.bubbles.bundle.min.js"></script>
    </div>
  </>
)

export default IndexPage
